import { Tabs } from 'react-vant'
import Convenient from '@/pages/Home/Phone/components/Convenient'
import { Helmet } from '@umijs/max'
import { useState } from 'react';

const Survey = () => {
  const [activeTab, setActiveTab] = useState('all');
  const itemList = [{
    key: 1,
    label: '物业服务',
    name: 'all',
    type: 1
  },{
    key: 2,
    label: '便民电话',
    name: 'Ing',
    type: 2
  }]

  const tabChange = (name: any) => {
    setActiveTab(name)
  };

  return (
    <div className='demo-tabs'>
      <Helmet>
        <title>常用电话</title>
      </Helmet>
      <Tabs active={activeTab} sticky={true} onChange={tabChange}>
        {itemList.map(item => (
          <Tabs.TabPane key={item.key} name={item.name} title={`${item.label}`}>
            {activeTab === item.name &&<Convenient type={item.type} ></Convenient>}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  )
}

export default Survey